import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';

export default function PaymentDetailsDialog({ isOpen, onClose, onSubmit, title = "Enter Payment Details", submitLabel = "Confirm Payment" }) {
  const [method, setMethod] = useState('');
  const [reference, setReference] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ method, reference });
    setMethod('');
    setReference('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-[#0F172A] border-white/10 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="font-['Outfit'] text-xl font-bold">{title}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <label className="block text-sm font-medium mb-2 text-[#94A3B8]">Payment Method *</label>
            <select 
              value={method} 
              onChange={(e) => setMethod(e.target.value)} 
              className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-lg focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none [&>option]:text-black text-white" 
              required 
              autoFocus
            >
              <option value="">Select Method...</option>
              <option value="Bank Transfer">Bank Transfer</option>
              <option value="Wire Transfer">Wire Transfer</option>
              <option value="Check">Check</option>
              <option value="Crypto">Crypto</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-2 text-[#94A3B8]">Transaction Reference</label>
            <input 
              type="text" 
              value={reference} 
              onChange={(e) => setReference(e.target.value)} 
              placeholder="e.g. TXN-12345678"
              className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-lg focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none text-white placeholder:text-white/20" 
            />
          </div>
          <DialogFooter className="gap-2 sm:gap-0 mt-6">
            <button type="button" onClick={onClose} className="px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg transition-colors text-sm font-medium">Cancel</button>
            <button type="submit" disabled={!method} className="px-4 py-2 bg-[#D4AF37] text-[#0A1128] font-bold rounded-lg hover:shadow-[0_0_15px_rgba(212,175,55,0.3)] transition-all text-sm disabled:opacity-50 disabled:cursor-not-allowed">{submitLabel}</button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
